var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyToClipboardIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M26.15 4.345 12.894 2.044a2.45 2.45 0 0 0-2.809 1.986l-.21 1.33h1.75l.175-1.033a.683.683 0 0 1 .787-.55l13.266 2.292a.673.673 0 0 1 .55.779l-2.292 13.247v6.221a2.38 2.38 0 0 0 .963-1.566l3.053-17.605a2.423 2.423 0 0 0-1.977-2.8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M17.584 14.031h-8.75v1.75h8.75zM17.584 17.811h-8.75v1.75h8.75zM17.584 21.591h-8.75v1.75h8.75z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M19.929 29.86H6.48a2.43 2.43 0 0 1-2.424-2.433V9.534A2.424 2.424 0 0 1 6.48 7.11h13.449a2.43 2.43 0 0 1 2.432 2.424v17.893a2.44 2.44 0 0 1-2.432 2.433M6.48 8.86a.674.674 0 0 0-.674.674v17.893a.68.68 0 0 0 .674.683h13.449a.683.683 0 0 0 .682-.683V9.534a.674.674 0 0 0-.682-.674z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyToClipboardIcon);
export default ForwardRef;